import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BackButton({ 
  to = null, 
  label = "Back", 
  className = "",
  variant = "default" // "default" | "light" | "header"
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  const variants = {
    default: "text-zinc-400 hover:text-white",
    light: "text-white/70 hover:text-white",
    header: "text-zinc-400 hover:text-white bg-zinc-800/50 hover:bg-zinc-800 px-3 py-2 rounded-lg"
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center gap-2 transition-colors ${variants[variant]} ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
}
